
import { defineComponent } from 'vue';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useEventBus } from '@white-label-helper/shared-composables';
import Notification from '../notification/notification.vue';

const DELAY_TO_CLOSE_NOTIFICATION = 3000 as const;
const eventBus = useEventBus();

type Notification = {
  id: number,
  message: string,
  topPositioning?: string,
}

export default defineComponent({
  name: 'NotificationsContainer',

  components: {
    Notification,
  },

  data () {
    return {
      notifications: [] as Notification[],
      topPositioning: '',
    };
  },

  mounted (): void {
    eventBus.$on('setNotificationData', this.setNotificationData);
    eventBus.$emit('notificationsContainerMounted');
  },

  beforeDestroy (): void {
    eventBus.$off('setNotificationData', this.setNotificationData);
  },

  methods: {
    setNotificationData (data: { message: string; topPositioning?: string }): void {
      this.notifications.push({
        message: data.message,
        id: (new Date()).getTime(),
      });
      if (data.topPositioning) {
        this.topPositioning = data.topPositioning;
      }
    },

    close (id: number): void {
      const index = this.notifications.findIndex(notification => notification.id === id);
      this.notifications.splice(index, 1);
    },

    closeWithDelay (id: number): void {
      setTimeout(() => {
        this.close(id);
      }, DELAY_TO_CLOSE_NOTIFICATION);
    },
  },
});
